function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTruck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8,5.635L8,28L9.382,28L10.106,26.553C10.275,26.214 10.621,26 11,26L21,26C21.379,26 21.725,26.214 21.894,26.553L22.618,28L24,28L24,5.634C21.272,4.425 17.944,4 16,4C14.215,4 10.745,4.427 8,5.635ZM6.553,4.106C9.738,2.513 13.907,2 16,2C18.271,2 22.264,2.514 25.447,4.106C25.786,4.275 26,4.621 26,5L26,29C26,29.552 25.552,30 25,30L22,30C21.621,30 21.275,29.786 21.106,29.447L20.382,28L11.618,28L10.894,29.447C10.725,29.786 10.379,30 10,30L7,30C6.448,30 6,29.552 6,29L6,5C6,4.621 6.214,4.275 6.553,4.106Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,9C3,8.448 3.448,8 4,8L28,8C28.552,8 29,8.448 29,9L29,14.5C29,14.951 28.698,15.346 28.263,15.465L23.34,16.807L21.974,22.725C21.886,23.108 21.581,23.404 21.196,23.481C20.323,23.655 18.087,24 16,24C13.913,24 11.677,23.655 10.804,23.481C10.419,23.404 10.114,23.108 10.026,22.725L8.66,16.807L3.737,15.465C3.302,15.346 3,14.951 3,14.5L3,9ZM5,10L5,13.736L9.763,15.035C10.118,15.132 10.392,15.416 10.474,15.775L11.826,21.632C12.831,21.795 14.474,22 16,22C17.526,22 19.169,21.795 20.174,21.632L21.526,15.775C21.608,15.416 21.882,15.132 22.237,15.035L27,13.736L27,10L5,10Z",
    style: {
      fill: "currentColor"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTruck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Truck.58515fef822693018f2f627e49797a19.svg";